import script from "./filmOversigtView.vue?vue&type=script&setup=true&lang=js"
export * from "./filmOversigtView.vue?vue&type=script&setup=true&lang=js"

import "./filmOversigtView.vue?vue&type=style&index=0&id=58681bb2&lang=css"

const __exports__ = script;

export default __exports__